import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/opobff/opo-platform');

export const opobffContactApiPaths = {
  contacts: withRoot('/contacts'),
  contactById: withRoot('/contacts/:contactId'),
  contactByUserId: withRoot('/contact/userid/:userId'),
} as const;

export const getOpobffContactApiUrl = {
  contacts: () => opobffContactApiPaths.contacts,
  contactById: (contactId: string) => replacePathParams(opobffContactApiPaths.contactById, { contactId }),
  contactByUserId: (userId: string) => replacePathParams(opobffContactApiPaths.contactByUserId, { userId }),
};
